<template>
  <div>
    EMBED URL
    <hr>
    <b-form-group :class="{'error-input' : $v.dataSetup.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.dataSetup.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.dataSetup.url.$error}">
      <label> Url </label>
      <j-input
        v-model="$v.dataSetup.url.$model"
        placeholder="https://" />
    </b-form-group>

    <div class="warning-message">
      <img src="@/assets/icon/warning.svg">
      <div class="d-flex flex-column">
        <p class="warning-title">Information</p>
        <p class="warning-info">
          URL must use HTTPS (Hypertext Transfer Protocol Secure)
        </p>
      </div>
    </div>

    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeForm">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveForm">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    dataSetup: {
      title: { required },
      url: { required },
    },
  },
  data() {
    return {
      dataSetup: {
        title: '',
        url: '',
      },
    };
  },
  computed: {
    generateData() {
      const data = {
        value_id: '0',
        widget_master_id: this.dataMaster.id,
        info: JSON.stringify({
          url: this.dataSetup.url,
          name: this.dataSetup.title,
        }),
        type: 3,
        position: this.dataMaster.position,
      };

      return data;
    },

    generateDataUpdate() {
      const data = {
        widget_master_id: this.dataMaster.id,
        info: JSON.stringify({
          url: this.dataSetup.url,
          name: this.dataSetup.title,
        }),
        type: 3,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };

      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      const info = JSON.parse(this.dataEdit.info);
      this.dataSetup.title = info.name;
      this.dataSetup.url = info.url;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateData;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataUpdate;
          this.updateWidget({ widgetId, dataParam });
        }

        this.closeForm();
      }
    },

    closeForm() {
      this.$emit('close-field');
      this.dataSetup.title = '';
      this.dataSetup.url = '';
      setTimeout(() => {
        this.$v.dataSetup.$reset();
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .warning-message {
    width: 100%;
    display: flex;
    background: rgba(255, 249, 196, 0.31);
    border-radius: 7px;
    margin-bottom: 33px;
    padding: 12px;
    gap: 7px;

    .warning-title {
      font-family: 'Poppins-Medium';
      font-size: 10px;
      line-height: 12px;
      color: #696014;
      margin-bottom: 2px;
    }

    .warning-info {
      font-family: 'Poppins-Regular';
      font-size: 10px;
      line-height: 12px;
      color: #696014;
      margin-bottom: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jEmbedUrlSetup.vue